import type { ChallengeDetails } from "../api/getChallengesForEmployee";
import { sortConditions } from "./sortConditions";

export const evaluateTeamChallenge = ({
    myTeam,
    details,
}: {
    myTeam: ChallengeDetails;
    details: ChallengeDetails[];
}): { result: "missed" | "exceeded" | "dropped" | "error" | "success"; winningTeam: string } => {
    let failureType = "" as "missed" | "exceeded" | "dropped" | "error" | "success" | "";
    let winningTeam = "";
    if (myTeam.wasSuccessful) {
        return { result: "success", winningTeam: myTeam.teamName ?? "yours" };
    }
    details.forEach((team) => {
        //skip this assessment if its is for your own team
        if (team.conditions !== myTeam.conditions) {
            if (team.wasSuccessful) {
                //if another team won, you lost
                failureType = "missed";
                winningTeam = team.teamName as string;
            }
        }
    });
    const myTeamConditions = sortConditions(myTeam.conditions);
    while (failureType === "") {
        myTeamConditions.forEach((condition) => {
            switch (condition.threshold) {
                case "TARGET":
                    if (condition.currentValue < condition.targetValue) {
                        //here, exceeded is just referring to the overall time limit.
                        //wanted to avoid extending the result constant. can rework if necessary
                        failureType = "exceeded";
                    }
                    break;
                case "UPPER_LIMIT":
                    if (condition.currentValue >= condition.targetValue) {
                        failureType = "dropped";
                    }
                    break;
                case "LOWER_LIMIT":
                    if (condition.currentValue < condition.targetValue) {
                        failureType = "dropped";
                    }
                    break;
            }
        });
        if (failureType === "") {
            failureType = "error";
        }
    }
    return { result: failureType, winningTeam };
};
